import React, { useState } from "react"
import { useWindowSize } from '@react-hook/window-size'
import { Row, Col } from "antd"

import TweetThemeChart from './TweetThemesChart'
import politicThemes from '../../assets/data/politicThemes.json'
import './TweetThemes.css'


function TweetThemesDetails() {
  const [width] = useWindowSize();
  const [referenceThemes] = useState(politicThemes)

  return (
    <div style={{ marginBottom: 40 }}>
      <Row type="flex">
        <Col span={ width >= 900 ? 22 : 22} offset={ width >= 900 ? 0 : 1}>
          <h1>Themes of political leaders</h1>
          <p>What are the topics that occupy the most space in the Twitter feed of political leaders? How do they stand out from each other?</p>
        </Col>
      </Row>
      <div> 
        <TweetThemeChart 
          marginBottom={40}
          title={'Ecology'}
          text={<div>Some key themes of the ideological line of each party stand out clearly in their speeches. Thus, <strong> Jean-Marc Nollet </strong> (Ecolo) and <strong> Meryem Almaci </strong> (Groen) are those who proportionally devote the most tweets to ecological and climate issues.</div>}
          themeData={referenceThemes.find(t => t.theme === 'écologie')}
        />
        <TweetThemeChart 
          marginBottom={80}
          title={'Security and justice'}
          text={<div> <strong> Bart De Wever </strong> (N-VA) and <strong> Tom Van Grieken </strong> (Vlaams Belang) are the ones who devote most of their tweets to questions of security and justice. </div>}
          themeData={referenceThemes.find(t => t.theme === 'sécurité_justice')}
        />
        <TweetThemeChart 
          marginBottom={20}
          title={'Employment and pensions'}
          text={<div>The theme of employment and pensions is particularly present in the tweets of the presidents of the left parties (PTB, PS and SP.A). It is <strong> Raoul Hedebouw </strong> (PTB) who devotes most of his messages to it.</div>}
          themeData={referenceThemes.find(t => t.theme === 'emploi_pensions')}
        />
      </div>
    </div>
  );
}

export default TweetThemesDetails;
